import { cn } from '@sohanemon/utils';
import { Portal } from '@sohanemon/utils/components';
import { useThemeStore } from '@sohanscript/theme/store';
import { SohanScriptLoader } from '@sohanscript/ui/sohanscript-loader';
import { memo, useEffect, useState } from 'react';

const EXISTING_MS = 400;

export const ThemeSwapOverlay = memo(function ThemeSwapOverlay() {
	const swapping = useThemeStore((state) => state.swapping);
	const swapId = useThemeStore((state) => state.swapId);
	const [mounted, setMounted] = useState(false);
	const [visible, setVisible] = useState(false);
	const [leaving, setLeaving] = useState(false);

	useEffect(() => {
		setMounted(true);
		return () => setMounted(false);
	}, []);

	useEffect(() => {
		if (swapping) {
			setVisible(true);
			setLeaving(false);
			return;
		}
		if (!visible) return;
		setLeaving(true);
		const id = setTimeout(() => {
			setVisible(false);
			setLeaving(false);
		}, EXISTING_MS);
		return () => clearTimeout(id);
	}, [swapping, visible]);

	if (!mounted || !visible) return null;

	// NOTE: portaled to body so no ancestor stacking context or the
	// preloader visibility hack can trap the overlay.
	return (
		<Portal>
			<div
				aria-hidden
				className={cn(
					'fixed inset-0 z-9998 flex items-center justify-center bg-background/85 backdrop-blur-sm transition-opacity duration-500',
					leaving ? 'pointer-events-none opacity-0' : 'opacity-100',
				)}
			>
				<center className="h-54 grid place-content-center">
					<div
						className={cn(
							'transition-transform duration-500 ease-[cubic-bezier(0.65,0,0.35,1)]',
							leaving && 'scale-[25]',
						)}
					>
						<SohanScriptLoader
							key={swapId}
							className="size-26"
							animationRestartDelay={null}
						/>
					</div>
				</center>
			</div>
		</Portal>
	);
});
